import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useRef, useContext } from 'react';
import { Icon } from '@livable/saas-react-components';
import { Button, Divider, Menu } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from 'src/contexts/globalContext';
import { LogoutModal } from 'src/components/shared/LogoutModal';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const ProfileMenu = observer(() => {
  const store = useStore();
  const navigate = useNavigate();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    logoutModalIsOpened = _useState2[0],
    setLogoutModalIsOpened = _useState2[1];
  const menuButtonRef = useRef(null);
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  const _useContext = useContext(GlobalContext),
    dashboardWizardStep = _useContext.dashboardWizardStep;
  const open = Boolean(anchorEl);
  const enableExternalMenuControl = () => {
    if (localStorage.getItem('livable_dashboard_wizard_is_shown') === 'true') {
      return false;
    } else if (dashboardWizardStep === null) {
      return false;
    } else {
      return true;
    }
  };
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const redirect = path => {
    navigate(path);
    setAnchorEl(null);
  };
  const handleLogoutModalOpen = () => {
    setLogoutModalIsOpened(true);
    setAnchorEl(null);
  };
  const handleLogoutModalClose = () => {
    setLogoutModalIsOpened(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "profile menu",
    onClick: handleClick,
    ref: menuButtonRef,
    "data-tut": "reactour__profile-menu",
    className: classes.menuTrigger,
    'custom-attribute': '74-profile-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "user"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    "data-no-focus-lock": true,
    anchorEl: menuButtonRef.current,
    open: enableExternalMenuControl() ? dashboardWizardStep === 2 : open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => redirect('/team_settings'),
    'custom-attribute': '75-profile-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  }), t('app_menus.my_team_settings')), !store.company.companyFeatureStore.disableFeeAssessmentMethod && !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => redirect('/fee-structure'),
    'custom-attribute': '76-profile-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins"
  }), t('app_menus.how_fees_are_assesed')), localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement(Divider, null), localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement(Button, {
    onClick: () => redirect('/profile-settings'),
    variant: "menuAction",
    'custom-attribute': '77-profile-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "account-circle"
  }), t('app_menus.profile_settings')), localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement(Divider, null), localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement(Button, {
    onClick: () => redirect('/payments'),
    variant: "menuAction",
    'custom-attribute': '78-profile-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "credit-card"
  }), t('app_menus.payments_and_subscription')), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: handleLogoutModalOpen,
    'custom-attribute': '79-profile-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "logout-box"
  }), t('general.log_out'))), /*#__PURE__*/React.createElement(LogoutModal, {
    isOpen: logoutModalIsOpened,
    handleOpen: handleLogoutModalOpen,
    handleClose: handleLogoutModalClose
  }));
});